module.exports = __webpack_public_path__ + "static/media/notif-expired.f47973a8.jpg";